import { IVisitStatusModel } from '@common/models/VisitStatusModel';

export interface IVisitChangeStatusRequest {
  visitId: number;
  currentVisitStatus: IVisitStatusModel;
  visitCompletionTypeId?: number;
  reason?: string;
  comments?: string;
  newVisitStatusEndpoint: VisitStatusUpdateEndpoint;
}

//Check_Out status not included because it
//has its own backendpoint.
export enum VisitStatusUpdateEndpoint {
  Check_In = 'checkin',
  Consultation = 'consultation',
  VetServices = 'vetservices',
}
